import { render, staticRenderFns } from "./CommunityGuidelines.vue?vue&type=template&id=0a151cf0&scoped=true"
import script from "./CommunityGuidelines.vue?vue&type=script&lang=js"
export * from "./CommunityGuidelines.vue?vue&type=script&lang=js"
import style0 from "./CommunityGuidelines.vue?vue&type=style&index=0&id=0a151cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a151cf0",
  null
  
)

export default component.exports